export async function CitaCreate( 
    citaResp, citaTipo, citaPac, citaFecha, citaHora, citaFinFecha, citaFinHora, citaObs, pacienteId, citaEsp, citaPostId, citaNotificacionId
     ) {
    const formData = {
        title: `us-${pacienteId}-cita-${citaFecha}`,
        slug: `us-${pacienteId}-cita-${citaFecha}`,
        status: "publish",
        // tratamiento: tratamientoId,
        meta: {
            citaResp: citaResp,
            citaTipo: citaTipo,
            citaPac: citaPac,
            citaEsp: citaEsp,
            citaPacId: pacienteId,
            citaFecha: citaFecha,
            citaHora: citaHora,
            citaFinFecha: citaFinFecha,
            citaFinHora: citaFinHora,
            citaObs: citaObs,
            citaPostId: citaPostId,
            citaNotificacionId: citaNotificacionId,
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/cita', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}

/**
 * Actualiza las citas de tipo WHO5, SCL90 y PSQI más recientes para un paciente cuando se crea una cita de refuerzo
 * @param {number} tratamientoId - ID del tratamiento actual
 * @param {number} pacienteId - ID del paciente
 * @param {string} nuevaFecha - Nueva fecha en formato YYYY-MM-DD
 * @param {string} nuevaFechaHora - Nueva hora en formato HH:MM
 * @returns {Object} Resultado de la actualización con información de las citas y cuestionarios actualizados
 */
export async function ActualizarCitasRefuerzo(
    tratamientoId, pacienteId, nuevaFecha, nuevaFechaHora
) {
    const authToken = sessionStorage.getItem('token');
    
    try {
        const response = await fetch('https://app.tavad.com/hce/wp-json/tavad/v2/actualizar-citas-refuerzo', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
            body: JSON.stringify({
                tratamientoId: tratamientoId,
                pacienteId: pacienteId,
                nuevaFecha: nuevaFecha,
                nuevaFechaHora: nuevaFechaHora
            }),
        });
        
        const resultado = await response.json();
        console.log('Actualización de citas para cuestionarios:', resultado);
        return resultado;
    } catch (error) {
        console.error('Error al actualizar citas de cuestionarios:', error);
        return { error: 'Error al actualizar citas de cuestionarios', details: error.message };
    }
}